import React, { useEffect, useRef, useState } from "react";
import { FiRepeat } from "react-icons/fi";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import n0 from "../../../assets/png/n0-0d01142d.png";
import n1 from "../../../assets/png/n1-79ffc280.png";
import n2 from "../../../assets/png/n2-8d24568c.png";
import n3 from "../../../assets/png/n3-36d0281f.png";
import n4 from "../../../assets/png/n4-cb84933b.png";
import n5 from "../../../assets/png/n5-49d0e9c5.png";
import n6 from "../../../assets/png/n6-6c01f296.png";
import n7 from "../../../assets/png/n7-5961a17f.png";
import n8 from "../../../assets/png/n8-a7675e89.png";
import n9 from "../../../assets/png/n9-a20f6f42.png";
import walletIcon from "../../../assets/png/wallet-7486f342.png";
import clockIcon from "../../../assets/png/time_a.png";
import playDoc from "../../../assets/png/playy.svg";
import walletBg from "../../../assets/png/walletbg-1dc79077.png";
import resultImg from "../../../assets/png/missningBg-78e01c86.png";
import resultCup from "../../../assets/png/golden_cup_PNG14555.png";
import ColorGameModal from "./ColorGameModal";
import { createGlobalStyle } from "styled-components";
import {
  FaArrowLeft,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
} from "react-icons/fa";
import socket from "../../../assets/socket"; // path to your socket.js
import { Helmet } from "react-helmet-async";
import GameLoader from "../GameLoader";
const base_url = process.env.REACT_APP_API_URL;

const winGo = [
  { title: "Win Go 30Sec", duration: 30, game: "30" },
  { title: "Win Go 1Min", duration: 60, game: "60" },
  { title: "Win Go 3Min", duration: 180, game: "180" },
  { title: "Win Go 5Min", duration: 300, game: "300" },
];

const numbers = [
  { image: n0 },
  { image: n1 },
  { image: n2 },
  { image: n3 },
  { image: n4 },
  { image: n5 },
  { image: n6 },
  { image: n7 },
  { image: n8 },
  { image: n9 },
];

const initialData = [];

const timersConfig = [
  { label: "30 sec", duration: 30 },
  { label: "1 min", duration: 60 },
  { label: "3 min", duration: 180 },
  { label: "5 min", duration: 300 },
];

const colorDot = (color) => {
  const bg =
    {
      red: "bg-danger",
      green: "bg-success",
      pink: "bg-pink",
      Red: "bg-danger",
      Green: "bg-success",
      Violet: "bg-pink",
    }[color] || "bg-secondary";
  return (
    <span
      className={`d-inline-block rounded-circle ${bg} mx-1`}
      style={{ width: "10px", height: "10px" }}
    />
  );
};

function ColorGame() {
  const token = localStorage.getItem("token");
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeGoIndex, setActiveGoIndex] = useState(0);
  const [showBalance, setShowBalance] = useState(0);
  const [period, setPeriod] = useState(0);
  const [gameData, setData] = useState(initialData);
  const [activeTab, setActiveTab] = useState("history");
  const [showModal, setShowModal] = useState(false);
  const [showHowToPlay, setShowHowToPlay] = useState(false);
  const [color, setColor] = useState([]);
  const [number, setNumber] = useState(null);
  const [randomNumber, setRandomNumber] = useState(null);
  const [startToGenrateRandomNumber, setStartToGenrateRandomNumber] =
    useState(false);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const lastRandomRef = useRef(null);

  const [userData, setUserData] = useState([]);
  const [userWinAmount, setUserWinAmount] = useState(0);
  const [userLoseAmount, setUserLoseAmount] = useState(0);
  const [userBetResult, setUserBetResult] = useState(null);
  const [showResultModalOnSocket, setShowResultModal] = useState(false);
  const [periodNumber, setPeriodNumber] = useState([]);
  const [activeGame, setActiveGame] = useState("30");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [page2, setPage2] = useState(1);
  const limit2 = 10;
  const [totalPages2, setTotalPages2] = useState(1);
  const [activeOrderId, setActiveOrderId] = useState(null);
  const [bodyScroll, setBodyScroll] = useState(true);

  const [timers, setTimers] = useState(
    timersConfig.map((timer) => ({
      ...timer,
      timeLeft: timer.duration,
      isRunning: true,
      showTimerModal: false,
      showResultModal: false,
      showModal: false,
    })),
  );

  const [lastCompletedPeriod, setLastCompletedPeriod] = useState(null);

  // ---------- Fetch Data (runs when activeGame, page or page2 change) ----------
  const fetchGameData = async (
    gameParam = activeGame,
    pageParam = page,
    page2Param = page2,
  ) => {
    try {
      setLoading(true);
      const response = await axios.get(`${base_url}/api/get/wingoGameData`, {
        params: {
          type: "user",
          game: gameParam,
          page: pageParam,
          page2: page2Param,
          limit,
          limit2,
        },
        headers: {
          Authorization: token,
        },
      });

      const processedData = response.data.data.map((item) => {
        let colors = [];

        if (item.number === 0) colors = ["Red", "Violet"];
        else if (item.number === 5) colors = ["Green", "Violet"];
        else if ([1, 3, 7, 9].includes(item.number)) colors = ["Green"];
        else if ([2, 4, 6, 8].includes(item.number)) colors = ["Red"];

        return { ...item, colors };
      });

      setShowBalance(response.data.userMoney);
      setData(processedData);
      setUserData(response.data.userData);
      setUserWinAmount(response.data.userWinAmount);
      setUserLoseAmount(response.data.userLoseAmount);
      setPeriodNumber(response.data.periodNumber);
      setLoading(false);
      setTotalPages(response.data.totalPages || 1);
      setTotalPages2(response.data.totalPages2 || 1);

      // Initialize last completed period
      if (
        processedData.length > 0 &&
        processedData[0].number !== undefined &&
        processedData[0].number !== null
      ) {
        setLastCompletedPeriod(processedData[0].period);
      }

      // Compute timer for activeGame
      const duration = parseInt(gameParam);
      const now = new Date();
      const totalSeconds = Math.floor(now.getTime() / 1000);
      const secondsInCycle = totalSeconds % duration;
      let timerSeconds = duration - secondsInCycle;
      if (timerSeconds === 0) timerSeconds = duration;

      const index = timersConfig.findIndex((t) => t.duration === duration);

      if (index !== -1) {
        setTimers((prev) =>
          prev.map((t, i) =>
            i === index
              ? {
                  ...t,
                  isRunning: true,
                  isFinished: false,
                  timeLeft: timerSeconds,
                }
              : { ...t, isRunning: false },
          ),
        );
        setActiveGoIndex(index);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.message || "Failed to fetch data");
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetch when activeGame or pagination changes
    fetchGameData(activeGame, page, page2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGame, page, page2]);

  // ---------- Socket logic (only for activeGame) ----------
  useEffect(() => {
    // named handlers so we can .off(...) exactly
    const handleConnect = () => {
      console.log("✅ Admin Connected to Real-time Wingo Updates");
    };

    const handleSocketData = async (payload, isResultUpdate = false) => {
      try {
        if (!payload || !payload.data) return;
        const { game } = payload.data;

        // Ignore updates for non-active games
        if (String(game) !== String(activeGame)) return;

        // Re-fetch latest data for active game
        await fetchGameData(activeGame, page, page2);

        // If this is a result update, check for user's bet on the completed period
        if (isResultUpdate) {
          // after fetchGameData, gameData state is updated; but response data is available inside fetch function only.
          // To be safe, we re-query the server above and then use userData from latest fetch via state update.
          // However state update is async; so to inspect latest result we will make a small request again to get the latest top result
          const topResponse = await axios.get(
            `${base_url}/api/get/wingoGameData`,
            {
              params: {
                type: "user",
                game: activeGame,
                page: 1,
                page2: 1,
                limit: 1,
                limit2: 1,
              },
              headers: {
                Authorization: token,
              },
            },
          );

          const topProcessed = (topResponse.data.data || []).map((item) => {
            let colors = [];
            if (item.number === 0) colors = ["Red", "Violet"];
            else if (item.number === 5) colors = ["Green", "Violet"];
            else if ([1, 3, 7, 9].includes(item.number)) colors = ["Green"];
            else if ([2, 4, 6, 8].includes(item.number)) colors = ["Red"];
            return { ...item, colors };
          });

          const latestResult = topProcessed[0];
          if (
            latestResult &&
            latestResult.number !== undefined &&
            latestResult.number !== null &&
            latestResult.period !== lastCompletedPeriod
          ) {
            setLastCompletedPeriod(latestResult.period);

            // fetch user's bets for that period (server returns userData in same endpoint)
            const userDataResponse = await axios.get(
              `${base_url}/api/get/wingoGameData`,
              {
                params: {
                  type: "user",
                  game: activeGame,
                  page: 1,
                  page2: 1,
                  limit: 50,
                  limit2: 50,
                },
                headers: {
                  Authorization: token,
                },
              },
            );

            const userBets = userDataResponse.data.userData || [];
            const userBetForPeriod = userBets.find(
              (b) => String(b.period) === String(latestResult.period),
            );

            if (userBetForPeriod) {
              setUserBetResult(userBetForPeriod);
              setShowResultModal(true);
              setBodyScroll(false);

              // Show toast for win/lose
              if (Number(userBetForPeriod.winAmount) > 0) {
                toast.success(
                  `You won ₹${parseFloat(userBetForPeriod.winAmount).toFixed(
                    2,
                  )}`,
                  {
                    position: "top-center",
                    autoClose: 3000,
                  },
                );
              } else {
                toast.error(
                  `You lost ₹${parseFloat(userBetForPeriod.betAmount).toFixed(
                    2,
                  )}`,
                  {
                    position: "top-center",
                    autoClose: 3000,
                  },
                );
              }

              // Reset the timer for the active duration
              const duration = parseInt(activeGame);
              const index = timersConfig.findIndex(
                (t) => t.duration === duration,
              );
              if (index !== -1) {
                setTimers((prev) =>
                  prev.map((t, i) =>
                    i === index
                      ? { ...t, timeLeft: duration, isRunning: true }
                      : t,
                  ),
                );
              }

              // Auto-hide result modal after 5s
              setTimeout(() => {
                setShowResultModal(false);
                setBodyScroll(true);
              }, 5000);
            }
          }
        }
      } catch (err) {
        console.error("❌ Failed to handle socket payload:", err);
      }
    };

    const handleWingoUpdate = (payload) => handleSocketData(payload, true);

    const handleBetByWingo = async (payload) => {
      try {
        // verify it's for active game
        const game = payload?.data?.game;
        if (String(game) !== String(activeGame)) return;

        // show a quick bet-placed toast
        toast.success("Bet Placed Successfully!", {
          position: "top-center",
          autoClose: 1500,
        });

        // Refresh data for active game (non-result)
        await handleSocketData(payload, false);
        console.log(payload);
      } catch (err) {
        console.error("Error handling bet_by_wingo:", err);
      }
    };

    // Attach listeners
    socket.on("connect", handleConnect);
    socket.on("wingo_update", handleWingoUpdate);
    socket.on("bet_by_wingo", handleBetByWingo);

    // Cleanup: remove exactly same handlers
    return () => {
      socket.off("connect", handleConnect);
      socket.off("wingo_update", handleWingoUpdate);
      socket.off("bet_by_wingo", handleBetByWingo);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGame, lastCompletedPeriod, page, page2]);

  // ---------- Per-second timers update ----------
  useEffect(() => {
    const interval = setInterval(() => {
      setTimers((prevTimers) =>
        prevTimers.map((timer) => {
          if (timer.isRunning) {
            const newTimeLeft =
              timer.timeLeft > 0 ? timer.timeLeft - 1 : timer.duration;
            return {
              ...timer,
              timeLeft: newTimeLeft,
              showTimerModal: newTimeLeft <= 5 && newTimeLeft >= 1,
              showResultModal: false,
            };
          }
          return {
            ...timer,
            showTimerModal: false,
            showResultModal: false,
          };
        }),
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [activeGoIndex]);

  const timeFormat = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return {
      minutes: String(minutes).padStart(2, "0"),
      seconds: String(seconds).padStart(2, "0"),
    };
  };

  const { minutes, seconds } = timeFormat(timers[activeGoIndex]?.timeLeft || 0);

  const labels = ["x1", "x5", "x10", "x100"];
  const handleWinGo = (index, game) => {
    // set and fetch
    if (String(activeGame) !== String(game)) {
      setActiveGame(game);
    } else {
      // already active: still fetch to refresh quickly
      fetchGameData(game, page, page2);
    }
    if (activeGoIndex !== index) {
      setActiveGoIndex(index);
    }
  };

  const handleNumberBalls = (idx) => {
    setShowModal(true);
    setBodyScroll(false);
    if (idx !== number) setNumber(idx);
    if (idx === 0) {
      setColor(["#D23838", "#9B48DB"]);
    } else if (idx === 5) {
      setColor(["#1AB355", "#9B48DB"]);
    } else if (idx === 1 || idx === 3 || idx === 7 || idx === 9) {
      setColor(["#1AB355"]);
    } else if (idx === 2 || idx === 4 || idx === 6 || idx === 8) {
      setColor(["#D23838"]);
    }
  };

  useEffect(() => {
    if (startToGenrateRandomNumber) {
      intervalRef.current = setInterval(() => {
        const random = Math.floor(Math.random() * 9 + 1);
        lastRandomRef.current = random; // store latest number
        setRandomNumber(random);
        setNumber(random);
      }, 200);

      timeoutRef.current = setTimeout(() => {
        setStartToGenrateRandomNumber(false);
        setRandomNumber(null);

        clearInterval(intervalRef.current);
        clearTimeout(timeoutRef.current);

        // Use the latest stored value
        handleNumberBalls(lastRandomRef.current);
      }, 2000);
    }

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startToGenrateRandomNumber]);

  const GlobalAnimationStyles = createGlobalStyle`
  @keyframes scaleBounce {
    0% { transform: scale(1); }
    25% { transform: scale(1.15); }
    50% { transform: scale(1); }
  }

  .animate-scale {
    animation: scaleBounce 0.6s ease-in-out infinite;
  }
`;

  useEffect(() => {
    // whenever activeGame changes, ensure the page numbers reset to 1 and fetch new data
    setPage(1);
    setPage2(1);
    fetchGameData(activeGame, 1, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeGame]);

  const getBackgroundStyles = (number) => {
    const parsedNumber = isNaN(number) ? number : Number(number);

    if (parsedNumber === 0) {
      return {
        backgroundImage: "linear-gradient(to top, violet, red)",
      };
    } else if (parsedNumber === 5) {
      return {
        backgroundImage: "linear-gradient(to top, violet, green)",
      };
    } else if ([1, 3, 7, 9].includes(parsedNumber)) {
      return {
        backgroundColor: "green",
      };
    } else if ([2, 4, 6, 8].includes(parsedNumber)) {
      return {
        backgroundColor: "red",
      };
    } else if (parsedNumber === "Big") {
      return {
        backgroundColor: "#DD9138",
      };
    } else if (parsedNumber === "Small") {
      return {
        backgroundColor: "#5088D3",
      };
    } else if (parsedNumber === "Red") {
      return {
        backgroundColor: "red",
      };
    } else if (parsedNumber === "Green") {
      return {
        backgroundColor: "green",
      };
    } else if (parsedNumber === "Violet") {
      return {
        backgroundColor: "violet",
      };
    }

    return {};
  };

  const handleDetails = (orderId) => {
    setActiveOrderId((prev) => (prev === orderId ? null : orderId));
  };

  const getUserResultText = (bet) => {
    if (bet.winAmount > 0) {
      return `+₹${parseFloat(bet.winAmount).toFixed(2)}`;
    } else {
      return `-₹${parseFloat(bet.betAmount).toFixed(2)}`;
    }
  };

  const getUserResultClass = (bet) => {
    return bet.winAmount > 0 ? "text-success" : "text-danger";
  };

  const handleModalClose = () => {
    setShowModal(false);
    setBodyScroll(true);
    setNumber(null);
    setColor([]);
  };

  const navigate = useNavigate();

  const numberImages = {
    0: n0,
    1: n1,
    2: n2,
    3: n3,
    4: n4,
    5: n5,
    6: n6,
    7: n7,
    8: n8,
    9: n9,
  };

  useEffect(() => {
    if (timers[activeGoIndex]?.showTimerModal) {
      setShowModal(false);
      setBodyScroll(true);
      setNumber(null);
      setColor([]);
    }
  }, [timers, activeGoIndex]);

  return (
    <>
      <style>{`
      .numbers-grid-wingo{
      display: grid;
          grid-template-columns: repeat(5, 4rem);,
      }

      @media (max-width: 400px) {
        .numbers-grid-wingo{
            grid-template-columns: repeat(5, 3rem);,
        }
            .wingo-container .fs-6 {
              font-size: 0.7rem !important;
            }
          .wingo-container .fs-5 {
            font-size: 1rem !important;
          }

          .wingo-container .timeRemainnig{
            padding: 0.20rem 0.3rem !important;
            margin-top: 8px;
          }

          .last_result_data{
            width: 1.6rem !important;
            height: 1.6rem !important;
          }
            th, tr{
              font-size: 0.8rem !important;
            }

            .gradient-text{
              font-size: 1rem !important;
            }

            .numbers_image{
              width: 3rem !important;
              height: 3rem !important;
              margin: 0 auto;
            }
      }
      `}</style>
      <Helmet>
        <title>
          Color Game – Play & Win | 10% Welcome Bonus + 10% on Every Deposit
        </title>
        <meta
          name="description"
          content="Play the Color Game on Henwin and enjoy a 10% bonus on your first recharge plus 10% extra on every deposit. Fast gameplay, instant rewards, and daily bonuses."
        />
        <meta
          name="keywords"
          content="color game, online color game, play color game, color prediction game, 10% welcome bonus, 10% deposit bonus, henwin color game, color win game, prediction game online, bonus games, instant win games"
        />
      </Helmet>

      <div className="min-vh-100 d-flex justify-content-center align-items-center bg-dark wingo-container">
        <div
          className="container p-3 border rounded shadow position-relative"
          style={{
            maxWidth: "420px",
            backgroundColor: "#22275B",
            maxHeight: "100%",
            overflowY: bodyScroll === true ? "scroll" : "hidden",
          }}
        >
          <ColorGameModal
            isOpen={showModal}
            onClose={handleModalClose}
            color={color}
            number={number}
            title={winGo[activeGoIndex].title}
            duration={winGo[activeGoIndex].duration}
            game={activeGame}
            period={periodNumber}
          />
          <HowToPlayModal
            isOpen={showHowToPlay}
            onClose={() => setShowHowToPlay(false)}
          />
          <ResultModal
            isOpen={
              timers[activeGoIndex]?.showResultModal || showResultModalOnSocket
            }
            result={gameData[0] || {}}
            userWinAmount={userWinAmount}
            userLoseAmount={userLoseAmount}
          />
          {/* Balance & Actions */}
          <div
            className="text-center mb-3 p-4 text-white rounded"
            style={{
              backgroundImage: `url(${walletBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundColor: "rgba(13, 109, 253, 0.53)",
            }}
          >
            <div className="d-flex justify-content-center align-items-center mb-2">
              {/* <FaArrowLeft
                size={20}
                className="text-white cursor-pointer"
                onClick={() => navigate(-1)}
                style={{ position: "absolute", left: "30px" }}
              /> */}
              <span className="fw-bold me-2 fs-4">
                ₹{parseFloat(showBalance).toFixed(2)}
              </span>
              <FiRepeat size={20} className="text-white cursor-pointer" />
            </div>
            <div className="d-flex justify-content-center align-items-center mb-2">
              <img
                src={walletIcon}
                alt="wallet"
                className="me-2"
                style={{ width: "24px", height: "24px" }}
              />
              <span>Main Wallet</span>
            </div>

            {/*
            <div className="d-flex justify-content-between gap-3">
              <Link
                to="/withdraw"
                className="bg-danger border-0 p-2 fw-bold w-50 rounded-pill text-white text-decoration-none"
              >
                Withdraw
              </Link>
              <Link
                to="/deposit"
                className="bg-success border-0 p-2 fw-bold w-50 rounded-pill text-white text-decoration-none"
              >
                Deposit
              </Link>
            </div>
            */}
            
          </div>

          {/* Welcome Message */}
          <div className="d-flex align-items-center mb-3 justify-content-between text-white">
            <p className="mb-0 me-3 fs-6">
              Hello, withdrawals typically take 1–2 hours to process. We
              appreciate your patience.
            </p>
            <button
              className="rounded-pill px-3 py-1 text-white"
              style={{
                background:
                  "linear-gradient(to bottom, rgb(193, 189, 236), rgb(50, 45, 136))",
                border: "none",
              }}
            >
              Details
            </button>
          </div>

          {/* WinGo Timers */}
          <div
            className="d-flex justify-content-between mb-3 rounded-4"
            style={{ backgroundColor: "#37499E" }}
          >
            {winGo.map((go, index) => (
              <div
                key={go.title}
                className={`text-center px-2 py-1 rounded-4 ${
                  activeGoIndex === index
                    ? "bg-primary text-white shadow-lg"
                    : "text-light"
                }`}
                style={{
                  width: "48%",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onClick={() => handleWinGo(index, go.game)}
              >
                <img
                  src={clockIcon}
                  alt="clock"
                  style={{ width: "3rem", height: "3rem" }}
                />
                <p className="mb-0 fs-6">{go.title}</p>
              </div>
            ))}
          </div>

          {/* How to Play & Time Remaining */}
          <div
            className="d-flex justify-content-between align-items-center p-2 mb-3 rounded-4 shadow-lg position-relative"
            style={{ backgroundColor: "#446DCD" }}
          >
            <span
              style={{
                position: "absolute",
                top: "-8px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "16px",
                height: "16px",
                backgroundColor: "#22275B",
                borderRadius: "50%",
                zIndex: 3,
              }}
            />
            <span
              style={{
                position: "absolute",
                top: "0",
                bottom: "0",
                left: "50%",
                transform: "translateX(-50%)",
                width: "2px",
                borderLeft: "2px dashed #22275B",
                zIndex: 1,
                height: "80%",
                margin: "auto",
              }}
            />
            <span
              style={{
                position: "absolute",
                bottom: "-8px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "16px",
                height: "16px",
                backgroundColor: "#22275B",
                borderRadius: "50%",
                zIndex: 3,
              }}
            />
            <div className="text-center text-white p-2 w-50 me-1">
              <div
                className="d-flex align-items-center mb-2 rounded-pill border border-black px-3 py-1 cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => setShowHowToPlay(true)}
              >
                <img
                  src={playDoc}
                  alt="how to play"
                  style={{ height: "20px", marginRight: "8px" }}
                />
                <p className="mb-0 fs-6">How to play</p>
              </div>
              <p className="small text-start fs-6">
                {winGo[activeGoIndex].title}
              </p>
              <div className="d-flex justify-content-start">
                {gameData.slice(0, 4).map((item, index) => (
                  <img
                    key={index}
                    src={numberImages[item.number]} // ← dynamic image
                    alt="last result"
                    className="img-fluid rounded-circle shadow mx-1 last_result_data"
                    style={{
                      width: "2rem",
                      height: "2rem",
                      objectFit: "cover",
                    }}
                  />
                ))}
              </div>
            </div>
            <div className="text-white text-center p-2 w-50">
              <p className="mb-0 text-end fs-5">Time remaining</p>
              <p className="h5 fw-bold d-flex justify-content-end gap-2">
                <>
                  <span
                    className="timeRemainnig p-2"
                    style={{ backgroundColor: "#1d1861", fontSize: "1rem" }}
                  >
                    {minutes[0]}
                  </span>
                  <span
                    className="timeRemainnig p-2"
                    style={{ backgroundColor: "#1d1861", fontSize: "1rem" }}
                  >
                    {minutes[1]}
                  </span>
                  <span
                    className="timeRemainnig p-2"
                    style={{ backgroundColor: "#1d1861", fontSize: "1rem" }}
                  >
                    :
                  </span>
                  <span
                    className="timeRemainnig p-2"
                    style={{ backgroundColor: "#1d1861", fontSize: "1rem" }}
                  >
                    {seconds[0]}
                  </span>
                  <span
                    className="timeRemainnig p-2"
                    style={{ backgroundColor: "#1d1861", fontSize: "1rem" }}
                  >
                    {seconds[1]}
                  </span>
                </>
              </p>
              <p className="h5 fs-5 fw-bold text-end">{periodNumber}</p>
            </div>
          </div>

          {/* bets section */}
          <div
            className="position-relative d-flex flex-column justify-content-between mb-3 rounded-2 p-2"
            style={{ backgroundColor: "#2B3270" }}
          >
            <TimerModal
              seconds={seconds}
              isOpen={timers[activeGoIndex]?.showTimerModal}
            />
            {/* Game Controls */}
            <div className="d-flex justify-content-between gap-2 mb-3">
              <button
                className="bg-success fs-5 w-100 border-0 text-white p-2"
                style={{
                  borderBottomLeftRadius: "1rem",
                  borderTopRightRadius: "1rem",
                }}
                onClick={() => {
                  setShowModal(true);
                  setBodyScroll(false);
                  setColor(["#1AB355"]);
                  setNumber(null);
                }}
              >
                Green
              </button>
              <button
                className="w-100 fs-5 border-0 text-white p-2 rounded-3"
                style={{ backgroundColor: "violet" }}
                onClick={() => {
                  setShowModal(true);
                  setBodyScroll(false);
                  setColor(["#9B48DB"]);
                  setNumber(null);
                }}
              >
                Violet
              </button>
              <button
                className="bg-danger fs-5 w-100 border-0 text-white p-2"
                style={{
                  borderBottomRightRadius: "1rem",
                  borderTopLeftRadius: "1rem",
                }}
                onClick={() => {
                  setShowModal(true);
                  setBodyScroll(false);
                  setColor(["#D23838"]);
                  setNumber(null);
                }}
              >
                Red
              </button>
            </div>

            {/* Numbers Grid */}
            <div
              className="d-grid gap-2 mb-3 rounded-3 py-3 px-5 numbers-grid-wingo"
              style={{
                backgroundColor: "#37499E",
                justifyContent: "center",
              }}
            >
              {numbers.map((num, idx) => (
                <React.Fragment key={idx}>
                  <GlobalAnimationStyles />
                  <img
                    src={num.image}
                    alt={`num-${idx}`}
                    className={`numbers_image rounded-circle border ${
                      randomNumber === idx ? "animate-scale" : ""
                    }`}
                    style={{ width: "3.5rem", height: "3.5rem" }}
                    onClick={() => handleNumberBalls(idx)}
                  />
                </React.Fragment>
              ))}
            </div>

            {/* Additional Controls */}
            <div className="d-flex justify-content-between mb-3 flex-wrap">
              <button
                className="m-1 px-1 border border-danger rounded text-danger bg-transparent"
                onClick={() => setStartToGenrateRandomNumber(true)}
              >
                Random
              </button>
              <div>
                {labels.map((label, index) => (
                  <button
                    key={index}
                    className={`m-1 p-2 rounded-3 border-0 ${
                      activeIndex === index
                        ? "bg-success"
                        : "btn-outline-success"
                    }`}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>

            <div className="d-flex border-0 rounded-pill overflow-hidden">
              <button
                className="text-white fs-5 w-50 p-2 border-0"
                style={{ backgroundColor: "#DD9138" }}
                onClick={() => {
                  setShowModal(true);
                  setBodyScroll(false);
                  setColor(["#DD9138"]);
                }}
              >
                Big
              </button>
              <button
                className="text-white fs-5 bg-primary w-50 p-2 border-0"
                onClick={() => {
                  setShowModal(true);
                  setBodyScroll(false);
                  setColor(["#5088D3"]);
                }}
              >
                Small
              </button>
            </div>
          </div>

          {/* Tabs */}
          <div className="d-flex justify-content-between">
            <button
              className="fs-5 border-0 text-white px-3 py-2 rounded-3"
              style={{
                backgroundColor:
                  activeTab === "history"
                    ? "#0d6efd"
                    : "rgba(29, 24, 97, 0.67)",
              }}
              onClick={() => setActiveTab("history")}
            >
              Game History
            </button>
            <button
              className="text-white fs-5 px-3 py-2 border-0 w-50 rounded-3"
              style={{
                backgroundColor:
                  activeTab === "bets" ? "#0d6efd" : "rgba(29, 24, 97, 0.67)",
              }}
              onClick={() => setActiveTab("bets")}
            >
              My Bets
            </button>
          </div>
          {/* Game History */}
          <div className="table-responsive border-0 mt-4 text-white rounded-4 shadow-lg">
            {activeTab === "history" ? (
              <>
                <table className="table table-hover text-center mb-0 text-white rounded-3">
                  <thead>
                    <tr style={{ backgroundColor: "#0d6efd" }}>
                      <th
                        style={{
                          fontSize: "1.1rem",
                          backgroundColor: "#0d6efd",
                        }}
                      >
                        Period
                      </th>
                      <th
                        style={{
                          fontSize: "1.1rem",
                          backgroundColor: "#0d6efd",
                        }}
                      >
                        Number
                      </th>
                      <th
                        style={{
                          fontSize: "1.1rem",
                          backgroundColor: "#0d6efd",
                        }}
                      >
                        Big/Small
                      </th>
                      <th
                        style={{
                          fontSize: "1.1rem",
                          backgroundColor: "#0d6efd",
                        }}
                      >
                        Color
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {gameData.map((item, idx) => {
                      const color1 = item.colors[0];
                      const color2 = item.colors[1];
                      const isGradient = item.colors.length === 2;
                      const numberColor = isGradient
                        ? `linear-gradient(to bottom, ${color1} 50%, ${color2} 50%)`
                        : color1;

                      return (
                        <tr key={item.id || idx}>
                          <td className="fw-semibold bg-transparent text-white">
                            {item.period}
                          </td>
                          <td className="bg-transparent text-center">
                            <span
                              key={`${item.id}-${item.number}`}
                              className="gradient-text"
                              style={{
                                fontWeight: "900",
                                fontSize: "2rem",
                                background: numberColor,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              {item.number}
                            </span>
                          </td>
                          <td className="fw-bold text-white bg-transparent">
                            {item.size}
                          </td>
                          <td className="bg-transparent">
                            {item.colors.map((clr, i) => (
                              <React.Fragment key={i}>
                                {colorDot(clr)}
                              </React.Fragment>
                            ))}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center mt-3 gap-2 mb-3">
                  <button
                    className="d-flex flex-column border-0 bg-primary rounded align-content-center justify-content-center p-2"
                    disabled={page <= 1}
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                  >
                    <FaChevronLeft />
                  </button>
                  <span className="align-self-center">
                    Page {page} of {totalPages}
                  </span>
                  <button
                    className="d-flex flex-column border-0 bg-primary rounded align-content-center justify-content-center p-2"
                    disabled={page >= totalPages}
                    onClick={() =>
                      setPage((prev) => Math.min(prev + 1, totalPages))
                    }
                  >
                    <FaChevronRight />
                  </button>
                </div>
              </>
            ) : (
              <>
                <table className="table table-hover text-center mb-0 text-white rounded-3">
                  <thead>
                    <tr style={{ backgroundColor: "#0d6efd" }}>
                      <th
                        style={{
                          fontSize: "1.1rem",
                          backgroundColor: "#0d6efd",
                        }}
                      >
                        Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData.map((item, idx) => (
                      <tr key={idx}>
                        <td className="fw-semibold bg-transparent text-white py-3">
                          <div className="d-flex align-items-center justify-content-between py-2 px-3">
                            <div
                              className="d-flex align-items-center gap-3"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDetails(item.id)}
                            >
                              <div
                                style={{
                                  fontSize: "2rem",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  ...getBackgroundStyles(
                                    item.number || item.size || item.color,
                                  ),
                                  width: "35px",
                                  height: "35px",
                                  borderRadius: "5px",
                                }}
                              >
                                {item.number !== undefined &&
                                item.number !== null
                                  ? item.number
                                  : item.size === "Big"
                                    ? "B"
                                    : item.size === "Small"
                                      ? "S"
                                      : item.color === "Green"
                                        ? "G"
                                        : item.color === "Red"
                                          ? "R"
                                          : item.color === "Violet"
                                            ? "V"
                                            : ""}
                              </div>

                              <div className="text-left">
                                <p className="mb-1">{item.period}</p>
                                <p className="mb-0">
                                  {new Date(item.create_at).toLocaleString()}
                                </p>
                              </div>
                            </div>
                            <div>
                              <p
                                className="mb-1"
                                style={{
                                  width: "75px",
                                  borderRadius: "3px",
                                  color:
                                    item.status === 0
                                      ? "orange"
                                      : item.status === 1
                                        ? "green"
                                        : "red",
                                  border:
                                    item.status === 0
                                      ? "1px solid orange"
                                      : item.status === 1
                                        ? "1px solid green"
                                        : "1px solid red",
                                }}
                              >
                                {item.status === 0
                                  ? "Pending"
                                  : item.status === 1
                                    ? "Success"
                                    : "Failed"}
                              </p>

                              <p
                                style={{
                                  color:
                                    item.status === 0
                                      ? "orange"
                                      : item.status === 1
                                        ? "green"
                                        : "red",
                                  textAlign: "end",
                                  margin: "0",
                                }}
                              >
                                {item.winAmount > 0
                                  ? "+" + parseFloat(item.winAmount).toFixed(2)
                                  : "-" + parseFloat(item.betAmount).toFixed(2)}
                              </p>
                            </div>
                          </div>
                          {activeOrderId === item.id && (
                            <div className="text-white">
                              <h1 className="fs-5 ml-2 text-start mb-1">
                                Details
                              </h1>
                              <p
                                className="d-flex align-items-center justify-content-between rounded p-2 text-white"
                                style={{ backgroundColor: "#2B3270" }}
                              >
                                <span>Period</span>
                                <span>{item.period}</span>
                              </p>
                              <p
                                className="d-flex align-items-center justify-content-between rounded p-2 text-white"
                                style={{ backgroundColor: "#2B3270" }}
                              >
                                <span>Purchase Amount</span>
                                <span>
                                  ₹{parseFloat(item.betAmount).toFixed(2)}
                                </span>
                              </p>
                              <p
                                className="d-flex align-items-center justify-content-between rounded p-2 text-white"
                                style={{ backgroundColor: "#2B3270" }}
                              >
                                <span>Amount After Tax</span>
                                <span className="text-danger">
                                  ₹{parseFloat(item.winAmount).toFixed(2)}
                                </span>
                              </p>
                              <p
                                className="d-flex align-items-center justify-content-between rounded p-2 text-white"
                                style={{ backgroundColor: "#2B3270" }}
                              >
                                <span>Tax</span>
                                <span>
                                  ₹{parseFloat(item.taxAmount).toFixed(2)}
                                </span>
                              </p>
                              <p
                                className="d-flex align-items-center justify-content-between rounded p-2 text-white"
                                style={{ backgroundColor: "#2B3270" }}
                              >
                                <span>Status</span>
                                <span
                                  className={` ${
                                    item.status === 0
                                      ? "text-warning"
                                      : item.status === 1
                                        ? "text-success"
                                        : "text-danger"
                                  }`}
                                >
                                  {item.status === 0
                                    ? "Pending"
                                    : item.status === 1
                                      ? "Success"
                                      : "Failed"}
                                </span>
                              </p>
                              <p
                                className="d-flex align-items-center justify-content-between rounded p-2 text-white"
                                style={{ backgroundColor: "#2B3270" }}
                              >
                                <span>Win/lose</span>
                                <span
                                  className={` ${
                                    item.winAmount > 0
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                >
                                  ₹
                                  {item.winAmount > 0
                                    ? parseFloat(item.winAmount).toFixed(2)
                                    : parseFloat(item.betAmount).toFixed(2)}
                                </span>
                              </p>
                              <p
                                className="d-flex align-items-center justify-content-between rounded p-2 text-white"
                                style={{ backgroundColor: "#2B3270" }}
                              >
                                <span>Order Time</span>
                                <span className="text-danger">
                                  {new Date(item.create_at).toLocaleString()}
                                </span>
                              </p>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center my-3 gap-2">
                  <button
                    className="border-0 bg-primary rounded px-2"
                    disabled={page2 <= 1}
                    onClick={() => setPage2((prev) => Math.max(prev - 1, 1))}
                  >
                    <FaChevronLeft />
                  </button>
                  <span className="align-self-center">
                    Page {page2} of {totalPages2}
                  </span>
                  <button
                    className="border-0 bg-primary rounded px-2"
                    disabled={page2 >= totalPages2}
                    onClick={() =>
                      setPage2((prev) => Math.min(prev + 1, totalPages2))
                    }
                  >
                    <FaChevronRight />
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ColorGame;

const TimerModal = ({ seconds, isOpen }) => {
  if (!isOpen) return null;
  return (
    <div
      className="position-absolute start-0 top-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: 10,
      }}
    >
      <span className="d-flex justify-content-center gap-4">
        <span
          className="w-50 h-75 p-4 rounded text-primary"
          style={{
            fontSize: "6rem",
            fontWeight: "900",
            backgroundColor: "rgb(22, 30, 79)",
          }}
        >
          {seconds[0]}
        </span>
        <span
          className="w-50 h-75 p-4 rounded text-primary"
          style={{
            fontSize: "6rem",
            fontWeight: "900",
            backgroundColor: "rgb(22, 30, 79)",
          }}
        >
          {seconds[1]}
        </span>
      </span>
    </div>
  );
};

const ResultModal = ({ isOpen, result, userWinAmount, userLoseAmount }) => {
  if (
    !isOpen ||
    !result ||
    result.number === undefined ||
    result.number === null
  )
    return null;

  const { number, size, colors } = result;
  const colorText = colors.length > 1 ? colors.join(" & ") : colors[0];

  const ResultScaleStyle = createGlobalStyle`
  @keyframes scaleBounce {
    0% { transform: scale(1); }
    50% { transform: scale(1.15); }
    100% { transform: scale(1); }
  }

  .animate-scale {
    animation: scaleBounce 0.6s ease-in-out infinite;
  }
`;

  return (
    <>
      <ResultScaleStyle />
      <div
        className="position-fixed start-0 w-100 h-100 d-flex justify-content-center align-items-center"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          zIndex: 50,
          top: "0",
        }}
      >
        <img
          src={resultImg}
          alt="result"
          className="position-absolute"
          style={{ objectFit: "cover", zIndex: 30, height: "335px" }}
        />
        <div
          className="position-absolute text-center d-flex flex-column justify-content-center align-items-center"
          style={{ zIndex: 30, color: "#fff" }}
        >
          <img
            src={resultCup}
            alt="result cup"
            style={{ height: "4rem", marginTop: "1rem" }}
          />
          <h1 className="fs-6">Round Result</h1>
          <p
            className={`fs-4 fw-bold ${
              userWinAmount > 0 ? "text-success" : "text-danger"
            }`}
            style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.5)", margin: 0 }}
          >
            {userWinAmount > 0 ? "+" : "-"}
            {userWinAmount > 0
              ? parseFloat(userWinAmount).toFixed(2)
              : parseFloat(userLoseAmount).toFixed(2)}
          </p>
          <div className="mt-4 d-flex justify-content-between gap-3 align-items-center">
            <p className="fs-6 fw-bold m-0 text-primary">{size}</p>
            <h1
              className="display-4 text-warning m-0 animate-scale"
              style={{
                fontWeight: "900",
                textShadow: "2px 5px 0px #000000",
              }}
            >
              {number}
            </h1>
            <p className="fs-6 fw-bold m-0 text-primary">
              {colors.length === 2 ? (
                <>
                  {colors[0]} <br /> {colors[1]}
                </>
              ) : (
                <>{colors[0]}</>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const HowToPlayModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const HowToPlayStyle = createGlobalStyle`
    .how-to-play-modal {
      background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
      border-radius: 20px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
      animation: modalSlideIn 0.3s ease-out;
    }

    @keyframes modalSlideIn {
      from {
        opacity: 0;
        transform: translateY(-50px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .rule-item {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      margin-bottom: 12px;
      padding: 16px;
      border-left: 4px solid #ffd700;
      transition: all 0.2s ease;
    }

    .rule-item:hover {
      background: rgba(255, 255, 255, 0.15);
      transform: translateX(5px);
    }
  `;

  return (
    <>
      <HowToPlayStyle />
      <div
        className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          zIndex: 1000,
        }}
      >
        <div
          className="how-to-play-modal position-relative p-4 text-white"
          style={{
            maxWidth: "330px",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          <button
            className="position-absolute end-0 top-0 p-2"
            onClick={onClose}
            style={{
              border: "none",
              background: "none",
              color: "white",
              fontSize: "1.5rem",
            }}
          >
            <FaTimes />
          </button>
          <h2 className="text-center mb-4" style={{ color: "#ffd700" }}>
            How to Play Win Go
          </h2>
          <div className="mb-3">
            <p className="text-center fs-6 mb-0">
              Bet on colors, numbers, or Big/Small to win big!
            </p>
          </div>
          <div className="rule-item">
            <h5 className="mb-2">🎯 Bet Types</h5>
            <ul className="mb-0 ps-3">
              <li>Red/Green/Violet: 2x payout</li>
              <li>Big (5-9): 2x payout</li>
              <li>Small (0-4): 2x payout</li>
              <li>Specific Number (1-9): 9x payout</li>
              <li>Number 0 or 5: 4.5x payout</li>
            </ul>
          </div>
          <div className="rule-item">
            <h5 className="mb-2">📊 Game Flow</h5>
            <p className="mb-0">
              Place your bet before time runs out. A random number 0-9 is drawn
              every round. Match your bet to win!
            </p>
          </div>
          <div className="rule-item">
            <h5 className="mb-2">💰 Payouts & Tax</h5>
            <p className="mb-0 small">
              2% tax on winnings. Net payout = Bet × Multiplier × 0.98
            </p>
          </div>
          <div className="rule-item">
            <h5 className="mb-2">⏱️ Rounds</h5>
            <p className="mb-0">
              Choose from 30s, 1m, 3m, or 5m rounds. Faster rounds = more
              action!
            </p>
          </div>
          <div className="text-center mt-4">
            <button
              className="btn btn-warning fw-bold px-4 py-2"
              onClick={onClose}
              style={{ borderRadius: "25px" }}
            >
              Got It! Let's Play
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
